/**
 * Example JavaScript singleton module
 */

var Grid = (function($) {

  function initGrid() {


    $('.masonry-grid').masonry({
        gutter: '.gutter-sizer',
        itemSelector: '.news__list-item',
        percentPosition: true,
        
    });
    
  }

  function init() {

    // return early if no corresponding module present
    if (!$('.masonry-grid').length) {
      return;
    }

    initGrid();

  }

  return {
    init: init
  };

}(jQuery));

jQuery(document).ready(Grid.init);
